<template>
  <v-dialog v-model="dialogOpen" width="400" persistent>
    <v-card>
      <v-card-title>Are you sure?</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <p>This will move <b>{{currentLead.id}}</b> to For Approval!</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :loading="loading" :disabled="loading">CONFIRM</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="loading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapGetters,mapActions } from "vuex";
  export default {
    props: ['dialogOpen'],
    data() {
      return {
        loading: false
      }
    },
    computed: {
      ...mapState('leads', ['currentLead']),
    },
    methods: {
      ...mapActions('leads', ['getLeadByID']),
      ...mapActions('products',['updateProductStatuses']),
      async submit() {
        this.loading = true;
        let data = {
          productId: this.currentLead.id,
          status: {status: 'For Approval'}
        }
        let success = await this.updateProductStatuses(data);
        this.close();
        if(success){
          await this.getLeadByID({id:this.currentLead.id});
        }
        this.loading = false;
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
